import * as React from "react";
import { Route } from "react-router";

import { DynamicPage } from "@montana/pages/dynamic-page.component";

import { PageTransition } from "./page-transition";

export const Routes: React.FC = React.memo((): JSX.Element => (
    <PageTransition>
        <Route path="*" component={DynamicPage} />
    </PageTransition>
));
